import React from 'react'
import parse from 'html-react-parser'

export function Errors({ fields, id }) {
  return (
    <>
      <h3 id={id}>Errors</h3>
      <table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((f, i) => (
            <tr key={i}>
              <td>
                {f.field}
                {f.optional && <sub className='label-optional'>optional</sub>}
              </td>
              <td>{f.type}</td>
              <td>
                <div>{parse(f.description)}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}
